import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { MODULE_IDS } from "../../constants/enums";
import {
  APP_FILE_G4SIGN_DOCUMENTS_ROUTE,
  APP_FILE_MANAGE_G4SIGN_DOCUMENTS_ROUTE,
  APP_FILE_MANAGE_G4SIGN_DOCUMENTS_ID_ROUTE,
} from "./g4sign.constants";

const DocumentsListPage= Loadable(
  lazy(() =>
    import("./dcouments/DocumentsListPage").then(({ DocumentsListPage }) => ({
      default: DocumentsListPage,
    }))
  )
);

const ManageDocuments = Loadable(
  lazy(() =>
    import("./components/UpsertDocument/UpsertDocumentWrapper").then(({ UpsertDocumentWrapper }) => ({
      default: UpsertDocumentWrapper,
    }))
  )
);

export const g4SignRoutes = [
  {
    path: `${APP_FILE_G4SIGN_DOCUMENTS_ROUTE}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.G4_SIGN]}>
        <DocumentsListPage />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${APP_FILE_MANAGE_G4SIGN_DOCUMENTS_ROUTE}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.G4_SIGN]}>
        <ManageDocuments  />
      </AuthorizedRoute>
    ),
  },

  {
    path: `${APP_FILE_MANAGE_G4SIGN_DOCUMENTS_ID_ROUTE}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.G4_SIGN]}>
        <ManageDocuments />
      </AuthorizedRoute>
    ),
  },
];
